import { Outlet, createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/vendor-panel')({
  beforeLoad: requireRole('vendor_panel'),
  component: Outlet,
})
